import * as React from "react";
function RefreshIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.248v4.5l.75-.75H.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-1.5 0m15-4.5v-4.5l-.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0m-1.01-3.984a9.002 9.002 0 0 1-9.956 14.544.75.75 0 1 0-.576 1.384 10.5 10.5 0 0 0 11.311-2.117c4.184-4.017 4.32-10.665.304-14.85a.75.75 0 0 0-1.082 1.04zM5.51 18.232a9.003 9.003 0 0 1 9.957-14.54.75.75 0 1 0 .576-1.385A10.5 10.5 0 0 0 4.749 4.42C.56 8.43.414 15.08 4.425 19.27a.75.75 0 0 0 1.084-1.038z"
  }));
}
export default RefreshIcon;